export default __webpack_public_path__ + "static/media/77822561862347127614730080593028934288944985961902016931195917784651400717.gif.a6208b25.mp4";